import { Localized } from "@fluent/react"
import { Box, CircularProgress, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { CopyToClipboardButton } from "../../../../app/components/CopyToClipboardButton";
import { CloseButton } from "../../../../app/components/CloseButton";
import { loadSysMailTemplates, selectAllSysMailTemplates, selectSysMailTemplates } from "./sysMailTemplatesSlice";
import { DownloadButton } from "../../../../app/components/DownloadButton";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { If } from "../../../../app/If";

interface SysMailTemplatesGenerateCodeDialogProps {
    onCancel: () => void;
}

export const SysMailTemplatesGenerateCodeDialog: React.FC<SysMailTemplatesGenerateCodeDialogProps> = ({ onCancel }) => {
    const dispatch = useAppDispatch()
    const { state: sysMailTemplatesState } = useAppSelector(selectSysMailTemplates)
    const sysMailTemplates = useAppSelector(state => selectAllSysMailTemplates(state))
    const [code, setCode] = useState("");

    const escapeSql = (text) => {
        if (!text) return '';
        return String(text).replace(/'/g, "''");
    };

    useEffect(() => {
        if (sysMailTemplatesState.type === "empty") {
            dispatch(loadSysMailTemplates())
        } else {
            const inserts = sysMailTemplates?.map(s => {
                const id = escapeSql(s.id);
                const type = escapeSql(s.type);
                const body = escapeSql(s.body);
                const bodyEN = escapeSql(s.bodyEN);
                const subject = escapeSql(s.subject);
                const subjectEN = escapeSql(s.subjectEN);
                const context = escapeSql(s.context);

                return `UPDATE [dbo].[SysMailTemplates] SET Body = '${body}', BodyEN = '${bodyEN}', Subject = '${subject}', SubjectEN = '${subjectEN}', IsFixed = ${s.isFixed ? 1 : 0}, IsInternal = ${s.isInternal ? 1 : 0} WHERE Id = '${id}';\nINSERT INTO [dbo].[SysMailTemplates] ([Id], [Type], [Body], [Subject], [ModifiedBy], [ModifyDate], [Context], [BodyEN], [SubjectEN], [IsFixed], [IsInternal]) SELECT '${id}', '${type}', '${body}', '${subject}', 'super', GETDATE(), '${context}', '${bodyEN}', '${subjectEN}', ${s.isFixed ? 1 : 0}, ${s.isInternal ? 1 : 0} WHERE NOT EXISTS (SELECT 1 FROM [dbo].[SysMailTemplates] WHERE Id = '${id}');`;
            }).join("\n\n");

            setCode(inserts ?? ""); 
        }
    }, [dispatch, sysMailTemplatesState, sysMailTemplates])

    return (
        <>
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Localized id="default-company-settings-generate-script">
                        <span>_Wygeneruj skrypt</span>
                    </Localized>
                    <div>
                        <DownloadButton name="migration_sysMailTemplates" value={code} />
                        <CopyToClipboardButton value={code} />
                    </div>
                </Box>
            </DialogTitle>
            <DialogContent>
                <If condition={sysMailTemplatesState.type === "loaded"} otherwise={<CircularProgress/>}>
                    <Typography
                        component="pre"
                        sx={{
                            padding: 2,
                            fontFamily: "monospace"
                        }}
                    >
                    {`${code}`}
                    </Typography>
                </If>
            </DialogContent>
            <DialogActions>
                <CloseButton loading={false} onClick={onCancel} />
            </DialogActions>
        </>               
    )
}